import { Injectable } from '@angular/core';
import { EventBus } from '@imagise/shared';
import { Observable } from 'rxjs';

interface IMessage {
  channel: string;
  data: unknown;
}

type MessageType<T> = {
  readonly name: string;
  readonly prototype?: T;
};

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  private readonly eventBus = new EventBus<{ message: IMessage }>();

  publish<T>(message: T): void {
    const channel = this.resolveChannel(message);
    this.eventBus.fire('message', { channel, data: message });
  }

  of<T>(messageType: MessageType<T>): Observable<T> {
    const channel = messageType.name;

    return new Observable<T>((subscriber) => {
      const dispose = this.eventBus.on('message', (message) => {
        if (message.channel === channel) {
          subscriber.next(message.data as T);
        }
      });

      return () => {
        dispose();
      };
    });
  }

  private resolveChannel<T>(message: T): string {
    if (!message || typeof message !== 'object') {
      return 'unknown';
    }

    const constructorRecord = (message as { constructor?: { name?: string } })
      .constructor;

    return constructorRecord?.name ?? 'unknown';
  }
}
